module.exports = __webpack_public_path__ + "static/media/step_livenew.8f45ed43.svg";